import { TasteProfile } from 'src/gqlReactTypings.generated.d';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { createSelectors } from '../create-selectors';

interface State {
  tasteProfile?: TasteProfile;
  loading: boolean;
  loaded: boolean;
}

interface Actions {
  setTasteProfile: (tasteProfile?: TasteProfile) => void;
  getTasteProfile: () => TasteProfile | undefined;
  setLoading: (loading: boolean) => void;
  setLoaded: (loaded: boolean) => void;
}

// Initialize a default state
export const INITIAL_STATE: State = {
  tasteProfile: undefined,
  loading: false,
  loaded: false,
};

export const useTasteProfileStore = create(
  immer<State & Actions>((set, get) => ({
    ...INITIAL_STATE,
    setTasteProfile: (tasteProfile?: TasteProfile) => {
      set({ tasteProfile });
    },
    getTasteProfile: () => get()?.tasteProfile,
    setLoading: (loading: boolean) => {
      set({ loading });
    },
    setLoaded: (loaded: boolean) => {
      set({ loaded });
    },
  }))
);

export const useTasteProfileStoreSelectors = createSelectors(useTasteProfileStore);
